<template>
  <v-container>
    <v-row align="start" justify="center">
      <v-col cols="12" sm="12" md="6" xl="4">
        <v-img src="@/assets/bluetheme/Strategy.png"></v-img>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="4">
        <p class="display-3 text-center">STRATEGY</p>
        <v-spacer></v-spacer>
        <v-divider />

        <v-card flat>
          <v-card-title class="headline mx-auto">
            <v-icon large color="primary" class="mr-5">mdi-strategy</v-icon>Tailor-made strategy for each account
          </v-card-title>

          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Auto Calculating</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Default Values</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Max Values</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-checkbox-marked-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Min Values</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
          <br />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChartSetup",
  data() {
    return {
      headers: [
        {
          text: "",
          align: "start",
          value: "name"
        },
        { text: "Webhook", value: "webhook" },
        { text: "Web App", value: "webapp" },
        { text: "Email", value: "email" },
        { text: "Telegram", value: "telegram" }
      ],
      flatforms: [
        {
          name: "TradingView",
          logo: "tradingview.png",
          webhook: "yes",
          webapp: "yes",
          email: "yes",
          telegram: "yes"
        },
        {
          name: "cTrader",
          logo: "ctrader.png",
          webhook: "yes",
          webapp: "yes",
          email: "yes",
          telegram: "yes"
        },
        {
          name: "Metatrader",
          logo: "metatrader.png",
          webhook: "yes",
          webapp: "yes",
          email: "yes",
          telegram: "yes"
        }
      ]
    };
  },
  methods: {
    flatformPath(item) {
      return require("@/assets/platforms/logos/" + item.logo);
    }
  }
};
</script>

<style>
</style>
